<template>
	<div v-if="chips.length" class="chips">
		<span v-if="countText" class="chips-count">{{ countText }}</span>
		<span v-for="chip in chips" :key="chip.key" class="chip">{{ chip.label }}<i class="fa-solid fa-xmark" @click="$emit('remove', chip)"></i></span>
		<a href="#" class="clear" @click.prevent="$emit('clear')">Clear all</a>
		<a href="#" class="clear" @click.prevent="$emit('save')">Save as view</a>
	</div>
</template>

<script>
export default {
	name: 'PeChips',
	props: {
		chips: { type: Array, default: () => [] },
		// a number renders as "1,234 match"; a string renders as given ("7 lines · 1 included")
		count: { type: [Number, String], default: null },
	},
	computed: {
		countText() { return typeof this.count === 'number' ? this.count.toLocaleString() + ' match' : this.count || '' },
	},
}
</script>
